module.exports = __webpack_public_path__ + "img/bee_with_flower.3ef72da5.svg";